import React from "react";
import { 
    Link, 
    VStack,
    Box
} from '@chakra-ui/react';
import { FaFacebookF, FaInstagram, FaLinkedin, FaWhatsapp, FaGithub } from "react-icons/fa"
import { useTheme } from '@chakra-ui/react';

const ContactLinks = () => {

    const theme = useTheme();
    const WhatsappButtonClicked = (event) => {

        const whatsappMessage = `Hey, My name is ________.
    I saw your portfolio and wanted to get in touch with you about _______________.`;
        const whatsappUrl = `https://wa.me/+601135702780/?text=${encodeURIComponent(whatsappMessage)}`;
        window.open(whatsappUrl, "_blank");
        }

  return (
    <VStack position={'fixed'} h={'100%'} top={'40%'}
    gap={'1.5em'} >

        <Link 
        href="https://github.com/ayaan278">
            <span size='md'>
            <FaGithub color={theme.colors.primary} style={{fontSize: '30px'}}/>
            </span>
        </Link>
        <Link 
            href="https://www.facebook.com/ayaan.ahmad.14/"        >
            <span size='md' >
                <FaFacebookF color={theme.colors.primary}
                    style={{
                        fontSize: '30px', 
                    }}
                />
            </span>
        </Link>
        <Link 
        href="https://www.instagram.com/_.ayaanii._/">
            <span size='md' >
            <FaInstagram color={theme.colors.primary} style={{fontSize: '30px' }}/>
            </span>
        </Link>
        <Link 
        onClick={WhatsappButtonClicked}>
            <span size='md' >
            <FaWhatsapp color={theme.colors.primary} style={{fontSize: '30px' }}/>
            </span>
        </Link>
        <Link 
        href="https://www.linkedin.com/in/ayaan-ahmad-06545614a/">
            <span size='md' >
            <FaLinkedin color={theme.colors.primary} style={{fontSize: '30px' }}/>
            </span>
        </Link>
        
        <Box 
       h="100%" variant='solid'
       orientation='vertical'  
       borderWidth= '2px' 
       borderStyle= "solid"
       borderRadius= '10'
       borderColor={theme.colors.primary} >
       </Box>

    </VStack>
  )
}

export default ContactLinks
